import {createAction} from 'redux-actions'
import {createActionObject} from '../../redux/utils'
import * as ActionTypes from './actionTypes'
import * as api from './apiCalls'
import {convertEffectiveDateInWorkSchedule} from './utils'
import {batched} from '../../redux/batch'
import {getYear} from './components/panels/importHolidays/selectors'
import {saveFile} from '../../atUtils'
import messageResource from '../../messageResource'

export const addEditingDay = createAction(ActionTypes.EDITING_DAYS_ADD)
export const removeEditingDay = createAction(ActionTypes.EDITING_DAYS_REMOVE)
export const removeCorporateDaysByYear = createAction(ActionTypes.CORPORATE_DAYS_REMOVE_BY_YEAR)

export const loadedDataSet = (loadedData) => dispatch => {
    dispatch(createActionObject(ActionTypes.LOADED_DATA_SET, loadedData))
}

export const loadData = (year) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.LOAD_DATA))
    dispatch(loadWorkScheduleData(
        year,
        () => dispatch(createActionObject(ActionTypes.LOAD_DATA_SUCCESS)),
        () => dispatch(createActionObject(ActionTypes.LOAD_DATA_FAILURE))
    ))
}

export const loadWorkScheduleData = (year, successCallback = () => {}, failureCallback = () => {}) => (dispatch) => {
    api.getPageData(year)
       .then(batched(data => {
           dispatch(loadedDataSet({
               corporateDays: {[year]: data.corporateDays},
               defaultWorkSchedules: convertEffectiveDateInWorkSchedule(data.defaultWorkSchedules)
           }))
           successCallback()
       }))
       .catch(({error}) => {
           failureCallback(error)
       })
}

export const selectYear = createAction(ActionTypes.YEAR_SELECTED)

export const addCorporateDay = (date, isWorking, title) => (dispatch) => {
    dispatch(addEditingDay(date))

    api.addCorporateDay(date, isWorking, title)
       .then((data) => {
           dispatch(setCorporateDayEditedResult(date, data))
       })
       .catch(() => {
           dispatch(removeEditingDay(date))
       })
}

export const deleteCorporateDay = (date) => (dispatch) => {
    dispatch(addEditingDay(date))

    api.deleteCorporateDay(date)
       .then((data) => {
           dispatch(setCorporateDayEditedResult(date, data))
       })
       .catch(() => {
           dispatch(removeEditingDay(date))
       })
}

export const loadCountries = () => (dispatch) => {
    dispatch(createActionObject(ActionTypes.LOAD_COUNTRIES))
    api.getCountries()
       .then(result => {
           dispatch(createActionObject(ActionTypes.LOAD_COUNTRIES_SUCCESS, result))
       })
       .catch(error => {
           console.error(error)
           dispatch(createActionObject(ActionTypes.LOAD_COUNTRIES_FAILURE))
       })
}

export const exportSchedule = () => (dispatch, getState) => {
    const year = getYear(getState())
    api.getCorporateScheduleICalendar(year)
       .then(result => {
           const fileName = messageResource.getMessage('work_schedule.header.export_holidays_file_name', [year])
           saveFile(result, fileName, {type: 'text/calendar', encoding: 'UTF-8'})
       })
       .catch(error => {
           console.error(error)
       })
}

const setCorporateDayEditedResult = (editedDate, data) => batched((dispatch) => {
    dispatch(loadedDataSet({
        corporateDays: {[editedDate.getFullYear()]: data.corporateDays},
        defaultWorkSchedules: convertEffectiveDateInWorkSchedule(data.defaultWorkSchedules)
    }))
    dispatch(removeEditingDay(editedDate))
})



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/actions.js